import React from 'react';
import { Card, Tooltip as MuiTooltip, useTheme } from '@mui/material';
import CsvIcon from '@mui/icons-material/Description';

interface CsvDownloadButtonProps {
    onClick: () => void;
    disabled?: boolean;
    tooltip?: string;
}

export const CsvDownloadButton: React.FC<CsvDownloadButtonProps> = ({
    onClick,
    disabled = false,
    tooltip = "Descargar CSV"
}) => {
    const theme = useTheme();
    // Only show in development environment
    if (process.env.NODE_ENV !== 'development') {
        return null;
    }

    return (
        <MuiTooltip title={tooltip}>
            <Card
                sx={{
                    p: 1.5,
                    minWidth: 48,
                    minHeight: 48,
                    cursor: 'pointer',
                    border: `2px solid ${theme.palette.divider}`,
                    backgroundColor: 'transparent',
                    transition: 'all 0.15s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover,
                        border: `2px solid ${theme.palette.divider}`,
                    },
                    opacity: disabled ? 0.5 : 1,
                    pointerEvents: disabled ? 'none' : 'auto',
                }}
                onClick={onClick}
            >
                <CsvIcon
                    sx={{
                        color: 'primary.main',
                        fontSize: 24
                    }}
                />
            </Card>
        </MuiTooltip>
    );
};
